function time(value) {
  const milliseconds = Date.parse(String(value ?? ""));
  return Number.isFinite(milliseconds) ? milliseconds : null;
}

function compact(seconds) {
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  const remainder = seconds % 60;
  return remainder ? `${minutes}m ${remainder}s` : `${minutes}m`;
}

export function timelineDurationMs(rows = []) {
  const spans = rows.map((row) => ({
    start: time(row.startedAt ?? row.started_at),
    finish: time(row.finishedAt ?? row.finished_at),
  }));
  if (spans.some((span) => span.start !== null && span.finish === null))
    return null;
  const starts = spans
    .map((span) => span.start)
    .filter((value) => value !== null);
  const finishes = spans
    .map((span) => span.finish)
    .filter((value) => value !== null);
  if (!starts.length || !finishes.length) return null;
  const duration = Math.max(...finishes) - Math.min(...starts);
  return duration >= 0 ? duration : null;
}

export function timelineDurationLabel(rows = []) {
  const duration = timelineDurationMs(rows);
  if (duration === null) return null;
  return `Worked for ${compact(Math.max(1, Math.round(duration / 1000)))}`;
}

export function runDurationLabel(startedAt, completedAt) {
  const start = time(startedAt);
  const finish = time(completedAt);
  if (start === null || finish === null || finish < start) return null;
  return `Worked for ${compact(Math.max(1, Math.round((finish - start) / 1000)))}`;
}
